import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Block, BlockHead, BlockHeadContent, BlockTitle} from '../../../components/block/Block';
import Button from '../../../components/button/Button';
import Icon from '../../../components/icon/Icon';
import {Card} from 'reactstrap';
import {Pagination} from '../../../components/pagination/Pagination';
import CompanyTable from './components/CompanyTable';
import {companyApi} from '../../../api';
import {ICompany} from './interfaces/ICompany';
import CompanyFilters from './components/CompanyFilters';
import {usePagination} from '../../../shared/hooks/usePagination';
import {useTranslation} from 'react-i18next';

const Company = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [companyList, setCompanyList] = useState<ICompany[]>([]);
  const {changeFilterHandler, page, setTotalPages, totalPages, handlePages, pagination} = usePagination();

  useEffect(() => {
    async function getAllCompanies() {
      const {data} = await companyApi.getAllCompanies(pagination);
      setCompanyList(data.data);
      setTotalPages(Math.ceil(data?.count / data?.perPage));
    }

    getAllCompanies();
  }, [pagination, setTotalPages]);
  return (
    <>
      <Block size="lg" className="mt-3">
        <BlockHead>
          <BlockHeadContent>
            <div className="row align-items-center gx-0 gx-lg-2">
              <div className="col-xxl-10 col-xl-9 col-lg-8 col-12">
                <BlockTitle tag="h4">{t('administrator.company.companyList')}</BlockTitle>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-4 col-12  text-end">
                <Button
                  className="btn-block"
                  color="primary"
                  onClick={() => {
                    navigate('/app/admin/company/create');
                  }}
                >
                  <Icon name="plus-sm" />
                  {t('administrator.company.addNewCompany')}
                </Button>
              </div>
            </div>
            <CompanyFilters changeFilterHandler={changeFilterHandler} pagination={pagination} />
          </BlockHeadContent>
        </BlockHead>
        <Card className="card-bordered card-preview">
          <CompanyTable companyList={companyList} setCompanyList={setCompanyList} />
        </Card>
      </Block>

      <div className="d-flex justify-content-end">
        {totalPages <= 1 ? '' : <Pagination page={page} totalPages={totalPages} handlePagination={handlePages} />}
      </div>
    </>
  );
};

export default Company;
